import React, { useEffect, useRef, useState } from "react";
import Layout from "../component/common/Layout/Layout";
// import Header, { DefaultFleetName } from "../component/common/Header/Header";
// import {
//   Card,
//   Menu,
//   MenuHandler,
//   MenuItem,
//   MenuList,
//   Typography,
// } from "@material-tailwind/react";
// import Icon from "@mdi/react";
// import {
//   mdiChevronDown,
//   mdiChevronLeft,
//   mdiChevronRight,
//   mdiChevronUp,
// } from "@mdi/js";
// import { Tooltip as ReactTooltip } from "react-tooltip";
// import { useAtom } from "jotai";
// import { getAllVehicles } from "../redux/action/action";
// import { useDispatch } from "react-redux";
// import { UseContextData } from "../context/dateContext";
// import { useNavigate } from "react-router-dom";
// import { HiOutlineArrowUp } from "react-icons/hi";
// import { useTranslation } from "react-i18next";
// import VehicleModel from "../component/common/popup/VehicleModel";
import { Space, Table, Tag } from "antd";
import huaweiIcon from "../assets/logos_and_icons/huawei new.svg";
import nokiaIcon from "../assets/logos_and_icons/Nokia-Logo.wine.svg";
import sdmcIcon from "../assets/logos_and_icons/SDMC_logo.svg";
import zteIcon from "../assets/logos_and_icons/ZTE new.svg";
import chileIcon from "../assets/logos_and_icons/Flag_of_Chile.svg";
import argentinaIcon from "../assets/logos_and_icons/Flag_of_Argentina.svg";

const FuelNet = () => {
  const columns = [
    {
      title: "Device ID",
      dataIndex: "id",
      key: "id",
      render: (text) => <a>{text}</a>,
      align: "center",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      align: "center",
    },
    {
      title: "Country",
      dataIndex: "country",
      key: "country",
      render: (text) => (
        <div>
          {text === "Chile" ? (
            <div className="flex justify-center">
              <img src={chileIcon} className="w-8 mr-2" alt="zte" />
              <a>{text}</a>
            </div>
          ) : (
            <div className="flex justify-center">
              <img src={argentinaIcon} className="w-8 mr-2" alt="zte" />
              <a>{text}</a>
            </div>
          )}
        </div>
      ),
      align: "center",
    },
    {
      title: "Vendor",
      dataIndex: "vendor",
      key: "vendor",
      render: (text) => (
        <div className="flex justify-center">
          {text === "ZTE" ? (
            <img src={zteIcon} className="w-10" alt="zte" />
          ) : (
            <img src={nokiaIcon} className="w-16" alt="nokia" />
          )}
        </div>
      ),
      align: "center",
    },
    {
      title: "Severity",
      dataIndex: "severity",
      key: "severity",
      render: (text) => (
        <div>
          {text === "ERROR" ? (
            <p className="text-red-500">{text}</p>
          ) : text === "INFO" ? (
            <p className="text-blue-500">{text}</p>
          ) : (
            <p className="text-[#ffcc00]">{text}</p>
          )}
        </div>
      ),
      align: "center",
    },
    {
      title: "Alert Type",
      dataIndex: "alertType",
      key: "alertType",
      align: "center",
    },
    {
      title: "Ticket Count",
      dataIndex: "ticketCount",
      key: "ticketCount",
      width: 100,
      align: "center",
    },
  ];
  const data = [
    {
      id: "ZTEYH8TP3D01394",
      date: "2023-11-22",
      country: "Chile",
      vendor: "ZTE",
      alertType: "InactiveDeviceAlert",
      ticketCount: 1,
      severity: "ERROR",
    },
    {
      id: "ZTEGD15665C8",
      date: "2023-12-16",
      country: "Chile",
      vendor: "ZTE",
      alertType: "AbusiveDownloaderAlert",
      ticketCount: 1,
      severity: "INFO",
    },
    {
      id: "ZTEGD1567BF6",
      date: "2023-12-25",
      country: "Chile",
      vendor: "ZTE",
      alertType: "AbusiveDownloaderAlert",
      ticketCount: 1,
      severity: "INFO",
    },
    {
      id: "ZTEGD1566190",
      date: "2024-01-20",
      country: "Chile",
      vendor: "ZTE",
      alertType: "AbusiveDownloaderAlert",
      ticketCount: 1,
      severity: "INFO",
    },
    {
      id: "ZTEGD15694E9",
      date: "2024-01-28",
      country: "Chile",
      vendor: "ZTE",
      alertType: "AbusiveDownloaderAlert",
      ticketCount: 1,
      severity: "INFO",
    },
    {
      id: "ZTEGD1568EAF",
      date: "2024-01-30",
      country: "Chile",
      vendor: "ZTE",
      alertType: "AbusiveDownloaderAlert",
      ticketCount: 1,
      severity: "INFO",
    },
    {
      id: "ZTEGD15665C8",
      date: "2024-02-06",
      country: "Chile",
      vendor: "ZTE",
      alertType: "PowerLevelAtTheLimitAlert",
      ticketCount: 1,
      severity: "WARNING",
    },
    {
      id: "ZTEGD156882D",
      date: "2024-02-06",
      country: "Chile",
      vendor: "ZTE",
      alertType: "PowerLevelAtTheLimitAlert",
      ticketCount: 1,
      severity: "WARNING",
    },
    {
      id: "ZTEGD1564FAA",
      date: "2024-02-06",
      country: "Chile",
      vendor: "ZTE",
      alertType: "PowerLevelAtTheLimitAlert",
      ticketCount: 1,
      severity: "WARNING",
    },
    {
      id: "ZTEGD1567DDA",
      date: "2024-02-06",
      country: "Chile",
      vendor: "ZTE",
      alertType: "PowerLevelAtTheLimitAlert",
      ticketCount: 1,
      severity: "WARNING",
    },
    {
      id: "ZTEGD1565AC3",
      date: "2024-02-07",
      country: "Chile",
      vendor: "ZTE",
      alertType: "AbusiveDownloaderAlert",
      ticketCount: 1,
      severity: "INFO",
    },
    {
      id: "ZTEGD1568E5A",
      date: "2024-02-11",
      country: "Chile",
      vendor: "ZTE",
      alertType: "PowerLevelAtTheLimitAlert",
      ticketCount: 1,
      severity: "WARNING",
    },
    {
      id: "ZTEGD15689AD",
      date: "2024-02-12",
      country: "Chile",
      vendor: "ZTE",
      alertType: "AbusiveDownloaderAlert",
      ticketCount: 1,
      severity: "INFO",
    },
    {
      id: "ZTEGD1569221",
      date: "2024-02-17",
      country: "Chile",
      vendor: "ZTE",
      alertType: "PowerLevelAtTheLimitAlert",
      ticketCount: 1,
      severity: "WARNING",
    },
    {
      id: "ZTEGD1565FDB",
      date: "2024-02-17",
      country: "Chile",
      vendor: "ZTE",
      alertType: "AbusiveDownloaderAlert",
      ticketCount: 1,
      severity: "INFO",
    },
    {
      id: "ZTEGD1564F62",
      date: "2024-02-18",
      country: "Chile",
      vendor: "ZTE",
      alertType: "AbusiveDownloaderAlert",
      ticketCount: 1,
      severity: "INFO",
    },
    {
      id: "ZTEGD15673C2",
      date: "2024-02-23",
      country: "Chile",
      vendor: "ZTE",
      alertType: "AbusiveDownloaderAlert",
      ticketCount: 1,
      severity: "INFO",
    },
    {
      id: "ZTEGD15654A8",
      date: "2024-02-23",
      country: "Chile",
      vendor: "ZTE",
      alertType: "AbusiveDownloaderAlert",
      ticketCount: 1,
      severity: "INFO",
    },
    {
      id: "ZTEGD1567E30",
      date: "2024-02-23",
      country: "Chile",
      vendor: "ZTE",
      alertType: "AbusiveDownloaderAlert",
      ticketCount: 1,
      severity: "INFO",
    },
    {
      id: "ZTEGD15692DB",
      date: "2024-02-23",
      country: "Chile",
      vendor: "ZTE",
      alertType: "AbusiveDownloaderAlert",
      ticketCount: 1,
      severity: "INFO",
    },
    {
      id: "ZTEGD1568117",
      date: "2024-02-24",
      country: "Chile",
      vendor: "ZTE",
      alertType: "AbusiveDownloaderAlert",
      ticketCount: 1,
      severity: "INFO",
    },
    {
      id: "ZTEGD15653BE",
      date: "2024-02-29",
      country: "Chile",
      vendor: "ZTE",
      alertType: "AbusiveDownloaderAlert",
      ticketCount: 1,
      severity: "INFO",
    },
    {
      id: "ZTEGD1568DB2",
      date: "2024-03-01",
      country: "Chile",
      vendor: "ZTE",
      alertType: "AbusiveDownloaderAlert",
      ticketCount: 1,
      severity: "INFO",
    },
    {
      id: "ZTEGD1564FAB",
      date: "2024-03-01",
      country: "Chile",
      vendor: "ZTE",
      alertType: "PowerLevelAtTheLimitAlert",
      ticketCount: 1,
      severity: "WARNING",
    },
    {
      id: "ZTEGD15696FB",
      date: "2024-03-01",
      country: "Chile",
      vendor: "ZTE",
      alertType: "AbusiveDownloaderAlert",
      ticketCount: 1,
      severity: "INFO",
    },
    {
      id: "ZTEGD1568BFF",
      date: "2024-03-04",
      country: "Chile",
      vendor: "ZTE",
      alertType: "PowerLevelAtTheLimitAlert",
      ticketCount: 1,
      severity: "WARNING",
    },
  ];

  return (
    <>
      <div className="overflow-hidden">
        <Layout>
          <div className="h-full ml-5">
            {/* <Header selectedMenu={(selectedOption) => selectedOption} /> */}
            <div className="flex items-center justify-between"></div>
            <div className="h-[calc(100%_-_40px)] pt-6 overflow-auto">
              <div className="flex justify-between items-center">
                <table className="w-full">
                  <tr>
                    <td className="w-[50%] py-4">
                      <div className="text-dark1 text-2xl dark:text-white">
                        {"List of Devices"}
                      </div>
                    </td>
                    <td className="py-4"></td>
                  </tr>
                </table>
              </div>
              <div className="overflow-y-auto">
                <Table
                  columns={columns}
                  dataSource={data}
                  pagination={{ pageSize: 20 }}
                />
              </div>
            </div>
          </div>
        </Layout>
      </div>
    </>
  );
};

export default FuelNet;
